import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { JwtService } from '../services/jwt.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {

        try {

            const authReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${JwtService.get().token}`)
            });
            return next.handle(authReq);

        } catch {

            if (this.router.url != '/pwd-recovery') {
                this.router.navigateByUrl('/login');
            }
            return next.handle(req);
        }
    }
    
}